
    import {computed, defineComponent} from 'vue';
    import {getPageLocale} from '@malt/dom';
    import {SelectedFreelancerResource} from '@/project-proposal/freelancer-selection/SelectedFreelancerResource';
    import {useGlobalProperties} from '@malt/vue3-use';

    export default defineComponent({
        name: 'FreelancerPriceDetails',
        props: {
            profile: {
                type: SelectedFreelancerResource,
                required: true,
            },
        },
        setup(props) {
            const {$msg} = useGlobalProperties();

            const isRepatriationText = computed<string>(() => {
                return $msg(
                    props.profile.isRepatriation
                        ? 'project.submission.header.shortlist.price.tooltip.REPATRIATION.fees'
                        : 'project.submission.header.shortlist.price.tooltip.fees',
                );
            });

            const priceFormatter = computed<Intl.NumberFormat>(
                () =>
                    new Intl.NumberFormat(getPageLocale(), {
                        style: 'currency',
                        currency: props.profile.price?.currencyCode || 'EUR',
                    }),
            );

            return {
                isRepatriationText,
                detailedPriceFormatter: priceFormatter,
            };
        },
    });
